import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-color" }
const _hoisted_2 = { class: "bg-color-model-page" }
const _hoisted_3 = { class: "main" }

import { tr } from 'element-plus/es/locale';
import { onMounted,ref } from 'vue';
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
	
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

	const lgoImg = require("@/assets/logo.png");
	const ify = (url) => {
		window.open(url)
	}
	const code=ref('')
	const getQueryParams = () => {
		let search = location.search;
		let queryParams = {};
		if (search) {
			search = search.substring(1); // 去掉问号
			const params = search.split('&');
			for (let i = 0; i < params.length; i++) {
				const pair = params[i].split('=');
				const paramName = decodeURIComponent(pair[0]);
				const paramValue = decodeURIComponent(pair[1]);
				queryParams[paramName] = paramValue;
			}
		}
		return queryParams.code;
	}
	onMounted(()=>{
		code.value=getQueryParams()
		console.log(code.value)
	})

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_header, { height: 100 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createVNode(vueQr, {
                    logoSrc: _unref(lgoImg),
                    text: `https://fy12348.cn/index?code=${code.value}`,
                    size: 150,
                    logoScale: .2
                  }, null, 8, ["logoSrc", "text"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createTextVNode("老板找律师，就上i法苑")
            ]),
            _: 1
          }),
          _createVNode(_component_el_footer, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (ify("https://h5.fy12348.cn")))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("立即进入")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})